import { NextContentfulImage } from "@components/Image";
import Link from "@components/Link/Link";
import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";
import { Image as ImageProps } from "@customTypes/image";
import { Link as LinkType } from "@customTypes/link";
import clsx from "clsx";
import styles from "./C256_ProofPointWrapper.module.scss";

export interface ProofPointData {
  description: string;
  descriptionRichText?: Document;
  title: string;
  titleLink?: LinkType;
  titleNumber?: string;
  bigTitle?: boolean;
  largeImage?: ImageProps;
  smallImage?: ImageProps;
  exploreCourseLink?: LinkType;
}

export const ProofPoint = (props: ProofPointData) => {
  const {
    description,
    descriptionRichText,
    title,
    titleLink,
    titleNumber,
    bigTitle,
    largeImage,
    smallImage,
    exploreCourseLink,
  } = props;
  const image = largeImage || smallImage;
  const titleHref = titleLink?.fields?.url;
  const titleContent = (
    <>
      {titleNumber && <span>{titleNumber}</span>}
      {title}
    </>
  );
  const descriptionContent = descriptionRichText ? (
    <RichTextDisplay richText={descriptionRichText} tinyMceRichText={null} />
  ) : description ? (
    <p>{description}</p>
  ) : null;

  return (
    <div className={styles.point}>
      {image && (
        <div className={styles.icon}>
          <NextContentfulImage
            src={image.fields.file.url}
            alt={image.fields.description || ""}
            width={768}
            height={432}
          />
        </div>
      )}
      <div className={styles.content}>
        <div>
          {title && (
            <h6 className={clsx(bigTitle && styles.h4)}>
              {titleHref ? (
                <Link href={titleHref}>{titleContent}</Link>
              ) : (
                titleContent
              )}
            </h6>
          )}
          {descriptionContent}
        </div>
        {exploreCourseLink?.fields?.url && (
          <Link className={styles.link} href={exploreCourseLink?.fields?.url}>
            {exploreCourseLink?.fields?.linkText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default ProofPoint;
